
import axios from 'util/axiosConfig';
import { SET_DICTATION_AUDIO_UPLOAD_PROGRESS } from '../appRedux/actions/mis/reportViewerAction';
import { getErrorMessage } from '../util/ErrorUtils';

const progressDone = (dispatch) => {
    dispatch({
        type: SET_DICTATION_AUDIO_UPLOAD_PROGRESS,
        payload: { uploading: true, percentCompleted: 100 }
    });
    setTimeout(() => {
        dispatch({
            type: SET_DICTATION_AUDIO_UPLOAD_PROGRESS,
            payload: { uploading: false, percentCompleted: 100 }
        });
    }, 300);
};

export const submitVisitReportDictationAPI = async (dictation, dispatch) => {
    const { reportId, dictationId, file, reportText, amendment } = dictation;
    if (file && file.manifest) {
        try {
            const response = await axios.post(`/api/v1/mis/submit-dictation-manifest`, {
                ...file.manifest,
                dictationId,
                reportText,
                amendment,
            });
            if (response.data) {
                progressDone(dispatch);
                return { success: true, data: response.data };
            }
        } catch (error) {
            console.warn("[dictation] manifest submit failed, falling back to legacy upload", error && error.message);
        }
        if (typeof file.buildLegacyFile !== "function") {
            return { success: false, error: "Dictation submit failed (no fallback available)" };
        }
        try {
            dictation = { ...dictation, file: file.buildLegacyFile() };
        } catch (error) {
            return { success: false, error: "Dictation submit failed (fallback encode failed)" };
        }
        return submitVisitReportDictationAPI(dictation, dispatch);
    }

    var formData = new FormData();
    formData.append('file', file);
    formData.append('reportId', reportId);
    formData.append('reportText', reportText);
    formData.append('dictationId', dictationId);
    formData.append('amendment', amendment);

    const config = {
        headers: { "content-type": "multipart/form-data" },
        onUploadProgress: event => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            dispatch({
                type: SET_DICTATION_AUDIO_UPLOAD_PROGRESS,
                payload: { uploading: true, percentCompleted: percent }
            });
            if (percent === 100) {
                setTimeout(() => {
                    dispatch({
                        type: SET_DICTATION_AUDIO_UPLOAD_PROGRESS,
                        payload: { uploading: false, percentCompleted: percent }
                    });
                }, 1000);
            }
        }
    };
    
    return await axios.post(`/api/v1/mis/submit-dictation-for-typing`, formData, config)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data }
            }
        }).catch(function (error) {
            return { success: false, error: getErrorMessage(error) }
        })
}

export const saveDictationAudioAPI = async (dictation, dispatch) => {

    const { reportId, dictationId, file } = dictation;
    if (file && file.manifest) {
        try {
            const response = await axios.post(`/api/v1/mis/save-dictation-audio-manifest`, {
                ...file.manifest,
                dictationId,
                fileName: file.fileName || null,
            });
            if (response.data) {
                progressDone(dispatch);
                return { success: true, data: response.data };
            }
        } catch (error) {
            console.warn("[dictation] manifest park failed, falling back to legacy upload", error && error.message);
        }
        if (typeof file.buildLegacyFile !== "function") {
            return { success: false, error: "Dictation save failed (no fallback available)" };
        }
        try {
            dictation = { ...dictation, file: file.buildLegacyFile() };
        } catch (error) {
            return { success: false, error: "Dictation save failed (fallback encode failed)" };
        }
        return saveDictationAudioAPI(dictation, dispatch);
    }

    let formData = new FormData();
    formData.append('file', file);
    formData.append('reportId', reportId);
    formData.append('dictationId', dictationId);

    const config = {
        headers: { "content-type": "multipart/form-data" },
        onUploadProgress: event => {
            const percent = Math.floor((event.loaded / event.total) * 100);
            dispatch({
                type: SET_DICTATION_AUDIO_UPLOAD_PROGRESS,
                payload: { uploading: true, percentCompleted: percent }
            });
            if (percent === 100) {
                setTimeout(() => {
                    dispatch({
                        type: SET_DICTATION_AUDIO_UPLOAD_PROGRESS,
                        payload: { uploading: false, percentCompleted: percent }
                    });
                }, 1000);
            }
        }
    };

    return await axios.post(`/api/v1/mis/save-dictation-audio`, formData, config)
        .then(function (response) {
            if (response.data) {
                return { success: true, data: response.data }
            }
        }).catch(function (error) {
            return { success: false, error: getErrorMessage(error) }
        })
}

export const getClarityAIFile = async (accessionNumber) => {
    return await axios.get(`/api/v1/get-clarityai-file`, {
        params: {
            fileName: accessionNumber
        }
    })
        .then(function (response) {
            return { success: true, visit: response.data };
        })
        .catch(function (error) {
            return { success: false, error: getErrorMessage(error) };
        });
}